<template>
<div class="not_found_wrap">
<img src="@/assets/not_found.png" alt="Not Found">
<p>Opps , Page Not Found !!</p>
<b-button tag="router-link"
                to="/Meny"
                type="is-dark">
                Go Meny
            </b-button>
</div>
</template>
<script>
export default {
   name:'notFound'
}
</script>

<style lang="scss" scoped>
.not_found_wrap{
    text-align: center;
    padding-top: 120px;
    height: calc(100vh - 80px);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    img{
        width: 800px;
        object-fit: contain;
    }
    p{
        color: #fff;
        font-size: 25px;
        font-weight: 600;
        margin-top: 40px;
        padding-left: 50px;
        margin-bottom: 30px;

    }
    button{
         padding-left: 50px;
        display: block;
    }
}
</style>